{
	"price_volume_url": "/api/nots/securityDailyTradeStat/58",
	"summary_url": "/api/nots/market-summary/",
	"supply_demand_url": "/api/nots/nepse-data/supplydemand",
	"turnover_url": "/api/nots/top-ten/turnover",
	"top_gainers_url": "/api/nots/top-ten/top-gainer",
	"top_losers_url": "/api/nots/top-ten/top-loser",
	"top_ten_trade_url": "/api/nots/top-ten/trade",
	"top_ten_transaction_url": "/api/nots/top-ten/transaction",
	"top_ten_turnover_url": "/api/nots/top-ten/turnover",
	"nepse_open_url": "/api/nots/nepse-data/market-open",
	"nepse_index_url": "/api/nots/nepse-index",
	"nepse_subindices_url": "/api/nots",
	"company_list_url": "/api/nots/company/list",
	"security_list_url": "/api/nots/security?nonDelisted=true",
	"NEPSE Index": "/api/nots/graph/index/58",
	"Banking SubIndex": "/api/nots/graph/index/51",
	"Development Bank Ind.": "/api/nots/graph/index/55",
	"Finance Index": "/api/nots/graph/index/60",
	"Hotels And Tourism": "/api/nots/graph/index/52",
	"HydroPower Index": "/api/nots/graph/index/54",
	"Investment": "/api/nots/graph/index/67",
	"Life Insurance": "/api/nots/graph/index/65",
	"Manufacturing And Pr.": "/api/nots/graph/index/56",
	"Microfinance Index": "/api/nots/graph/index/64",
	"Mutual Fund": "/api/nots/graph/index/66",
	"Non Life Insurance": "/api/nots/graph/index/59",
	"Others Index": "/api/nots/graph/index/53",
	"Trading Index": "/api/nots/graph/index/61",
	"company_daily_graph": "/api/nots/market/graphdata/daily/",
	"company_details": "/api/nots/security/",
	"company_price_volume_history": "/api/nots/market/history/security/",
	"company_floorsheet": "/api/nots/security/floorsheet/",
	"floor_sheet": "/api/nots/nepse-data/floorsheet",
	"todays_price": "/api/nots/nepse-data/today-price",
	"live-market": "/api/nots/lives-market",
	"market-depth": "/api/nots/nepse-data/marketdepth/",
	"disclosure": "/api/nots/news/companies/disclosure",
	"wasm_url": "/assets/prod/css.wasm",
	"prove_url": "/api/authenticate/prove",
	"stock_daily_price": "/api/nots/market/graphdata/",
	"refresh_url": "/api/authenticate/refresh-token",
	"index_history": {
		"NEPSE Index": "/api/nots/index/history/58",
		"Banking SubIndex": "/api/nots/index/history/51",
		"Development Bank Ind.": "/api/nots/index/history/55",
		"Finance Index": "/api/nots/index/history/60",
		"Hotels And Tourism": "/api/nots/index/history/52",
		"HydroPower Index": "/api/nots/index/history/54",
		"Investment": "/api/nots/index/history/67",
		"Life Insurance": "/api/nots/index/history/65",
		"Manufacturing And Pr.": "/api/nots/index/history/56",
		"Microfinance Index": "/api/nots/index/history/64",
		"Mutual Fund": "/api/nots/index/history/66",
		"Non Life Insurance": "/api/nots/index/history/59",
		"Others Index": "/api/nots/index/history/53",
		"Trading Index": "/api/nots/index/history/61"
	}
}